function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_659",
  "data-name": "Group 659",
  transform: "translate(-388 -1280)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_802",
  "data-name": "Group 802",
  transform: "translate(-562.453 502.78)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_199",
  "data-name": "Path 199",
  d: "M1062.454,833.221a56,56,0,1,1-56-56,56,56,0,0,1,56,56",
  transform: "translate(0 0)",
  fill: "#eeeff3"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_801",
  "data-name": "Group 801",
  transform: "translate(1000.467 803.16)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_200",
  "data-name": "Path 200",
  d: "M985.845,840.05a1.825,1.825,0,0,0-1.9,1.9v6.85a1.887,1.887,0,0,0,.533,1.33,1.785,1.785,0,0,0,1.37.571h9.134a1.95,1.95,0,0,0,1.9-1.9v-6.85a1.789,1.789,0,0,0-.571-1.37,1.891,1.891,0,0,0-1.332-.533Zm.076-45.284a1.79,1.79,0,0,0-1.37.57,1.891,1.891,0,0,0-.533,1.332v35.77a1.827,1.827,0,0,0,1.9,1.9H994.9a1.827,1.827,0,0,0,1.9-1.9v-35.77a1.9,1.9,0,0,0-.533-1.332,1.79,1.79,0,0,0-1.37-.57Z",
  transform: "translate(-983.942 -794.766)",
  fill: "#fff"
}))));

var SvgNA = function SvgNA(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNA, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/n-a.4ec6a346.svg";
export { ForwardRef as ReactComponent };